import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowsDesc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 18 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.287 16.54V.4H3.62v16.14l-2.407-2.407L.035 15.31l4.418 4.419 4.42-4.419-1.18-1.178zM17.462 8.161l-4.418-4.419-4.419 4.419 1.178 1.178 2.407-2.406v6.318h1.667V6.933l2.407 2.406z" })
});
export default SvgArrowsDesc;
